// components/Sidebar.tsx

import React from 'react';
import config from '../config';

export type PageKey = 'home' | 'accounts' | 'spending' | 'budgets' | 'transactions';

interface SidebarProps {
  isOpen: boolean;
  currentPage: PageKey;
  onNavigate: (page: PageKey) => void;
  onClose: () => void;
  onLogout: () => void;
}

const navItems: { label: string; page: PageKey }[] = [
  { label: 'Home',       page: 'home'         },
  { label: 'Accounts',   page: 'accounts'     },
  { label: 'Transactions', page: 'transactions' },
];

const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  currentPage,
  onNavigate,
  onClose,
  onLogout,
}) => {
  const handleNav = (page: PageKey) => {
    onNavigate(page);
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`sidebar-overlay ${isOpen ? 'open' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Drawer */}
      <nav className={`sidebar ${isOpen ? 'open' : ''}`} aria-label="Main navigation">
        <div className="sidebar-logo">{config.name}</div>

        <div className="sidebar-nav">
          {navItems.map(({ label, page }) => (
            <button
              key={page}
              className={`sidebar-link ${currentPage === page ? 'active' : ''}`}
              onClick={() => handleNav(page)}
              aria-current={currentPage === page ? 'page' : undefined}
            >
              {label}
            </button>
          ))}
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
